import { ConvertBoxDataType } from '../../convertBox.index';

export enum __BuyUUSDWithdrawMethodsEnums {
    wallet,
    get,
    account,
}

export interface __BuyUUSDWithdrawMethodConvertBoxProps {
    onSubmit: (e: ConvertBoxDataType) => void;
    onBack: () => void;
    data?: ConvertBoxDataType;
    loading?: boolean;
}
